import styled from 'styled-components';
import { Radio, RadioProps } from 'react-uforms';
import { colors } from '@ch/common/const/color';
import { font } from '../../../const/font';
import { SizeProps } from '../../../const/size';

export const FormRadioStyled = styled.label`
  position: relative;
`;

export const FormRadioLabel = styled.span<{ $size?: SizeProps }>`
  display: flex;
  align-items: center;
  justify-content: start;
  font-size: ${({ $size }) => ($size ? `${font.size[$size]}px` : `${font.size.md}px`)};
  color: ${colors?.primary};
`;
export const FormRadioIcon = styled.span`
  min-width: 16px;
  width: 16px;
  height: 16px;
  box-shadow: 0 0 0 2px ${colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 8px;
  border-radius: 50%;
`;

export const FormRadioInput = styled(Radio)<RadioProps>`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  &:checked ~ ${FormRadioLabel} {
    ${FormRadioIcon} {
      background-color: ${colors.primary};
      border: 3px solid ${colors.white};
      background-color: rgb(30, 40, 70);
      box-shadow: 0 0 0 2px ${colors.primary};
      min-width: 16px;
      width: 16px;
      height: 16px;
    }
  }

  &:disabled {
    & ~ ${FormRadioLabel} {
      cursor: not-allowed;
      ${FormRadioIcon} {
        cursor: not-allowed;
        background-color: ${colors.white};
        box-shadow: 0 0 0 2px ${colors.grayMedium};
      }
    }
    &:checked {
      & ~ ${FormRadioLabel} {
        ${FormRadioIcon} {
          background-color: ${colors.grayMedium};
        }
      }
    }
  }
`;
